/* eslint-disable no-inner-declarations */
import get from 'lodash/get';

import ChatAPI from '../../utils/chatAPI/connection';
import { authTokenSelector } from '../auth/selectors';
import {
  loggedUserIdSelector,
  hasProviderProfileSelector,
  selectTeamId,
  selectTeamUserId,
} from '../context/selectors';
import { CHAT_ATTACHMENTS_URI, CHAT_SOCKET_URI } from '../../constants/env';
import { LOGOUT_NOTIFICATIONS_ERRORS } from '../../constants/errors';
import * as dashboardWS from '../dashboard/real-time-updates';

import actions from './actions';
import { paymentInfoModalActions } from '../programs/payment-info-modal';

let connection;

export function connect() {
  return function(dispatch, getStore) {
    try {
      const state = getStore();
      const authToken = authTokenSelector(state);
      const userId = loggedUserIdSelector(state);
      const teamId = selectTeamId(state);
      const teamUserId = selectTeamUserId(state);
      const isProvider = hasProviderProfileSelector(state);

      const config = {
        authToken,
        userId,
        attachmentsUploadUrl: `${CHAT_ATTACHMENTS_URI}/upload`,
        socketUrl: CHAT_SOCKET_URI,
        teamId,
        teamUserId,
        isProvider,
      };

      connection = new ChatAPI(config);
      dispatch(actions.setChatModuleInstance(connection));

      connection.on('connection_opened', data => {
        // here you can get some connection data
        // trigger for ready state
        dispatch(actions.connectionOpened());
      });

      connection.on('connection_ready', data => {
        // here you can get some system channel data
        // trigger for ready state
        dispatch(actions.connectionReady());
      });

      connection.on('conversation_changed', data => {
        dispatch(actions.conversationChanged(data));
      });

      connection.on('bump_activity', data => {
        dispatch(actions.setChannelData(data));
      });

      connection.on('remove_messages', data => {
        const { channel, removed } = data;

        dispatch(actions.conversationChanged(channel));
        dispatch(
          actions.removeMessages({
            userId: channel.userId,
            removedMsgs: removed,
          }),
        );
      });

      connection.on('reload_history', () => {
        dispatch(actions.reloadHistory());
      });

      connection.on('new_channel_activity', data => {
        dispatch(actions.newChannelActivity(data));
      });

      connection.on('remove_chatroom', data => {
        dispatch(actions.removeChannel(data));
      });

      connection.on('remove_context_user', data => {
        dispatch(actions.removeContextUser(data));
      });

      connection.on('blocked_channels', data => {
        dispatch(actions.toggleBlockedChat(data));
      });

      connection.on('update_chat', data => {
        dispatch(actions.updateChat(data));
      });

      connection.on('join_request_created', data => {
        dispatch(actions.newJoinRequest(data));
      });

      connection.on('join_request_accepted', data => {
        dispatch(actions.joinRequestAccepted(data));
      });

      connection.on('join_request_declined', data => {
        dispatch(actions.joinRequestDeclined(data));
      });

      connection.on('new_post', data => {
        dispatch(actions.newPost(data));
      });

      connection.on('new_post_comment', data => {
        dispatch(actions.newPostComment(data));
      });

      connection.on('new_comment_reply', data => {
        dispatch(actions.newCommentReply(data));
      });

      connection.on('member_invitation_created', data => {
        dispatch(actions.newCommunityInvite(data));
      });

      connection.on('member_invitation_accepted', data => {
        dispatch(actions.communityInviteAccept(data));
      });
      connection.on('member_invitation_declined', data => {
        dispatch(actions.communityInviteDecline(data));
      });

      connection.on('community_complaint', subscribeToNewComplaints);
      connection.on('comment_complaint', subscribeToNewComplaints);
      connection.on('post_complaint', subscribeToNewComplaints);

      connection.on(LOGOUT_NOTIFICATIONS_ERRORS.MULTIPLE_DEVICES, logOut);
      connection.on(LOGOUT_NOTIFICATIONS_ERRORS.ENTITY_EXCEPTION, logOut);

      /** APPOINTMENTS */
      connection.on('appointsments:change_status', data => {
        dispatch(dashboardWS.actions.changeStatus(data));
      });
      connection.on('appointsments:change_payment_status', data => {
        dispatch(dashboardWS.actions.changePaymentStatus(data));
      });
      connection.on('appointsments:update_copay', data => {
        dispatch(dashboardWS.actions.updateCopay(data));
      });

      connection.on('appointsments:change_room', data => {
        dispatch(dashboardWS.actions.changeRoom(data));
      });

      connection.on('appointsments:pin', data => {
        dispatch(dashboardWS.actions.pin(data));
      });
      connection.on('appointsments:create', data => {
        dispatch(dashboardWS.actions.created(data));
      });

      connection.on('appointsments:remove_from_dashboard', data => {
        dispatch(dashboardWS.actions.removeFromDashboard(data));
      });

      connection.on('event:inbox_task_completed', data => {
        dispatch(actions.completeInboxTask(data));
      });

      connection.on('event:paya_accountvault_form_url', data => {
        dispatch(paymentInfoModalActions.receivePayaForm(data));
      });

      connection.on('event:paya_transaction_successful', data => {
        dispatch(
          paymentInfoModalActions.receivedPayaPaymentSuccessResponse(data),
        );
      });

      connection.on('event:paya_transaction_declined', data => {
        dispatch(
          paymentInfoModalActions.receivedPayaPaymentErrorResponse(data),
        );
      });

      connection.on('phx_reply', data => {
        const errorReason = get(data, 'response.reason', null);
        if (errorReason === 401) {
          connection.disconnect();
        }
      });

      function logOut(data) {
        dispatch(actions.logout(data));
      }

      // noinspection JSAnnotator
      function subscribeToNewComplaints(data) {
        const payload = get(data, 'message.payload.data.complaint');
        dispatch(actions.newComplaint(payload));
      }

      // connect
      connection.connect();
    } catch (err) {
      connection.disconnect();
      dispatch(actions.setConnectError(err));
    }
  };
}



// WEBPACK FOOTER //
// ./src/redux/chatConnection/actionsAsync.js